import { actionTypes } from '../actions/account.action';
const initialState = {
    accounts: {
        data: []
    },
    account: {
        gateway: null,
        rate: 'parcial'
    },
    error: {},
    success: false
}

const accountReducer = (state = initialState, { type, payload }) => {
    switch (type) {

    case actionTypes.INDEX:
        return { ...state, ...payload }

    case actionTypes.CHANGE:
        return {
            ...state,
            account: (payload === 'clear') ? {gateway: null, rate: 'parcial'} : {
                ...state.account,
                ...payload
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default accountReducer